import { ErrorBoundary as OgErrorBoundary } from 'react-error-boundary'
import type { FC, PropsWithChildren, ReactElement } from 'react'
import type { FallbackProps as ErrorBoundaryFallbackProps } from 'react-error-boundary'

type AnyProps = Exclude<object, null>

export interface LoadingComponentErrorBoundaryProps<Props extends AnyProps> extends PropsWithChildren {
  mainComponentProps: Props
  fallback: ReactElement | null | FC<Props & ErrorBoundaryFallbackProps>
}

export const LoadingComponentErrorBoundary = <Props extends AnyProps>(
  props: LoadingComponentErrorBoundaryProps<Props>
): ReturnType<FC> => {
  const { fallback: ErrorFallback, mainComponentProps, children } = props

  if (typeof ErrorFallback === 'function') {
    return (
      <OgErrorBoundary fallbackRender={(errorFallbackProps) => <ErrorFallback {...mainComponentProps} {...errorFallbackProps} />}>
        {children}
      </OgErrorBoundary>
    )
  }

  return <OgErrorBoundary fallback={ErrorFallback}>{children}</OgErrorBoundary>
}
